import Vue from "vue";
import Router from "vue-router";
import store from "@/shared/store";
import Home from "@/app/admin/admin.vue";
import app from "@/main";

Vue.use(Router);

// 获取路由配置
function getRouterModules() {
  let routers = [];
  const modules = require.context("./modules", false, /\.js$/);
  modules.keys().forEach(key => {
    routers = routers.concat(modules(key).default);
  });
  return routers;
}

const configRouters = getRouterModules();

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Home,
      exact: true,
      meta: { requireAuth: true },
      children: configRouters
    },
    {
      path: "/login",
      name: "login",
      meta: { title: "登录" },
      component: () =>
        import(/* webpackChunkName: "account" */ "@/app/account/login.vue")
    },
    {
      path: "*",
      redirect: "/dashboard"
    }
  ]
});

router.beforeEach((to, from, next) => {
  let prefix = "lucasGC-中台管理系统";
  to = fixMeta(to);
  document.title = prefix + "-" + to.meta.title;

  //执行登录
  store.dispatch("doLogin").then(() => {
    if (to.matched.filter(route => route.meta.requireAuth).length > 0) {
      if (store.getters.isLogin) {
        next();
      } else {
        next({
          path: "/login",
          query: { redirect: to.fullPath }
        });
      }
    } else {
      next();
    }
  });
});
router.afterEach((to, from) => {
  if (from.path === "/") {
    app.$mount("#app");
  }
});

function fixMeta(route) {
  if (route.params.status) {
    //修正订单
    let fix_title = "",
      fix_key = route.params.status + "-order",
      fix_permission = "post_manager.post_" + route.params.status + "_list";
    switch (route.params.status) {
      case "process":
        fix_title = "进行中订单";
        break;
      case "closed":
        fix_title = "已关闭订单";
        break;
      case "done":
        fix_title = "已完成订单";
        break;
      default:
        break;
    }
    route.meta.title = fix_title;
    route.meta.key = fix_key;
    route.meta.permission = fix_permission;
  }
  return route;
}

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router;
